import { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import {
  getMuted,
  setMuted,
  startAmbient,
  stopAmbient,
  ensureContextResumed,
} from "@/lib/sound";

export default function MuteToggle({ className = "" }) {
  const [muted, setMutedState] = useState(getMuted());

  useEffect(() => {
    if (!muted) startAmbient();
    // Resume audio context on first user gesture (browser autoplay policy).
    const resume = () => ensureContextResumed();
    window.addEventListener("pointerdown", resume, { once: true });
    window.addEventListener("keydown", resume, { once: true });
    return () => {
      window.removeEventListener("pointerdown", resume);
      window.removeEventListener("keydown", resume);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggle = () => {
    const next = !muted;
    setMuted(next);
    setMutedState(next);
    if (next) {
      stopAmbient();
    } else {
      startAmbient();
      ensureContextResumed();
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-full border border-white/10 text-white/70 hover:text-[#EAB308] hover:border-[#EAB308] transition-colors duration-300 ${className}`}
      aria-label={muted ? "Unmute ambient sound" : "Mute ambient sound"}
      data-testid="mute-toggle"
      data-muted={muted ? "true" : "false"}
      title={muted ? "Sound off" : "Sound on"}
    >
      {muted ? (
        <VolumeX className="w-4 h-4" />
      ) : (
        <Volume2 className="w-4 h-4" />
      )}
    </button>
  );
}
